import { Component, OnInit, Input } from '@angular/core';
import { CouponListService } from './coupon-list.service';
import _ from 'lodash';
import * as moment from 'moment';
import { DateService } from '@root/shared/service/date.service';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateService } from '@root/shared/service/translate.service';
enum CouponStatus {
  Unuse = 0,
  Used = 1,
  Forbid = 2,
  Expired = 3
}

enum CouponType {
  Extend = 0,
  Discount = 1,
  MoneyOff = 2,
  Voucher = 3
}

@Component({
  selector: 'host-coupon-list',
  templateUrl: './coupon-list.component.html',
  styleUrls: ['./coupon-list.component.scss']
})
export class CouponListComponent implements OnInit {
  readonly CouponStatus: typeof CouponStatus = CouponStatus;
  readonly CouponType: typeof CouponType = CouponType;
  listOfCoupon = [];
  exchangeCouponCode;
  @Input() pageType: 'view' | 'operate' = 'view';
  @Input() selectedCoupon;
  constructor(
    private couponListService: CouponListService,
    private dateService: DateService,
    private modalService: NzModalService,
    private messageService: NzMessageService,
    private translate: TranslateService,
    private modalRef: NzModalRef
  ) { }

  ngOnInit() {
    this.fetchCouponList();
  }

  fetchCouponList() {
    this.couponListService.fetchCouponList().subscribe(res => {
      const list = _.get(res, 'data.list') || [];
      const filtered = _.filter(list, item => (item.status === CouponStatus.Unuse || item.status === CouponStatus.Expired) && item.type !== CouponType.Extend);

      this.listOfCoupon = this.formatCouponList(filtered);
    });
  }

  requestExchangeCoupon () {
    this.couponListService.exchangeCoupon({ code: this.exchangeCouponCode }).subscribe(res => {
      if (res.error_code === 0) {
        this.messageService.success(
          this.translate.syncGet('success.coupon_list.add')
          );
        this.fetchCouponList();
      }
    });
  }

  formatCouponList (list) {
    return _.map(list, item => {
      let name = '';
      let validity = '';
      let htmlClass = null;

      switch (item.status) {
        case CouponStatus.Expired:
          // validity = '已过期';
          validity = this.translate.syncGet('modal.coupon.list.status_expires');
          htmlClass = 'expired';
          break;
        case CouponStatus.Unuse:
          const date = item.end_time;
          const diff = moment(date).diff(moment(), 'd');
          if (diff >= 30) {
            // validity = `${this.dateService.format(date, ['YMD'])}过期`;
            validity = this.translate.syncGet('modal.coupon.list.status_expire', { date: this.dateService.format(date, ['YMD']) });
          } else if (diff >= 0) {
            // validity = `${diff}天后过期`;
            validity = this.translate.syncGet('modal.coupon.list.status_will_expire', { day: diff });
            htmlClass = "will-expire"
          } else {
            // validity = '已过期';
            validity = this.translate.syncGet('modal.coupon.list.status_expires');
            htmlClass = 'expired';
          }
          break;
      }

      name = item.title;

      return  { ...item, name, validity, htmlClass };

    });
  }

  displayExchangeCouponModal (tpl) {
    this.modalService.create({
      // nzTitle: '兑换优惠券',
      nzTitle: this.translate.syncGet('modal.coupon.list.add'),
      nzContent: tpl,
      nzWidth: 480,
      nzOnOk: () => this.requestExchangeCoupon()
    });
  }

  onConfirm () {
    this.modalRef.destroy({
      coupon: this.selectedCoupon
    });
  }

  onClickItem (item) {
    if (item.status === CouponStatus.Expired) {
      return;
    }
    const code = item.code;
    if (code !== this.selectedCoupon) {
      this.selectedCoupon = code;
    } else {
      this.selectedCoupon = null;
    }
    console.log('code: ', code, ' selected: ', this.selectedCoupon);
  }


  private getRelativeDate (date: string) {
    const diff = moment(date).diff(moment(), 'd');
    if (diff >= 30) {
      return `${this.dateService.format(date, ['YMD'])}过期`;
    } else {
      return `${diff}天后过期`;
    }
  }

}
